<template>
    <div>
        <Head>
            <title>Кабінет</title>
        </Head>
        <Header pageName="Кабінет" :cart-count="cartCount"/>
        <div class="mx-auto max-w-2xl mt-4 px-4 py-4 sm:px-6 sm:py-8 lg:max-w-7xl lg:px-8">
            <div>
                <h2 class="page-title">Мої замовлення</h2>
            </div>
                <div
                    class="flex flex-col md:flex-row mt-4 items-center md:justify-between"
                    :class="isOwner ? 'justify-between' : 'justify-end'"
                >
                <div v-if="isOwner" class="flex flex-col md:flex-row justify-start items-center mb-4 md:mb-0">
                    <Link
                        :href="route('table.reports')"
                        class="flex items-center h-12 btn-indigo uppercase tracking-widest btn-booking text-uppercase rounded-lg justify-center"
                    >
                        Адмін панель
                    </Link>
                    <Link
                        :href="route('cabinet.watchman')"
                        class="flex items-center h-12 btn-indigo uppercase tracking-widest btn-booking text-uppercase rounded-lg justify-center sm:ml-4"
                    >
                        Кабінет сторожа
                    </Link>
                </div>
                <div class="p-4 bg-white">
                    <p><span class="inline-block w-4 h-4 bg-green-300 mr-2"></span> Замовлення оплачено</p>
                    <p><span class="inline-block w-4 h-4 bg-gray-200 mr-2"></span> Замовлення не оплачено</p>
                </div>
            </div>
            <div class="bg-white rounded-md shadow overflow-x-auto mt-4" v-for="order in orders.data" :key="order.id">
                <table class="w-full whitespace-nowrap">
                    <tr class="text-left font-bold">
                        <th class="pb-4 pt-6 px-6">Номер</th>
                        <th class="pb-4 pt-6 px-6">Ім'я</th>
                        <th class="pb-4 pt-6 px-6">Телефон</th>
                        <th class="pb-4 pt-6 px-6">Озеро</th>
                        <th class="pb-4 pt-6 px-6">Назва місця</th>
                        <th class="pb-4 pt-6 px-6">Тип</th>
                        <th class="pb-4 pt-6 px-6">Дата</th>
                        <th class="pb-4 pt-6 px-6">Чек</th>
                    </tr>
                    <tr v-for="preOrder in order.preOrders" :key="preOrder.id"
                        class="hover:bg-gray-100 focus-within:bg-gray-100 h-10"
                        :class="{'bg-green-300' : order.is_payed}"
                    >
                        <td class="border-t">
                            <p class="flex items-center px-6 py-4 focus:text-indigo-500">
                                {{ order.id }}
                            </p>
                        </td>
                        <td class="border-t">
                            <p class="flex items-center px-6 py-4 focus:text-indigo-500">
                                {{ order.name }}
                            </p>
                        </td>
                        <td class="border-t">
                            <p class="flex items-center px-6 py-4 focus:text-indigo-500">
                                {{ order.phone }}
                            </p>
                        </td>
                        <td class="border-t">
                            <p class="flex items-center px-6 py-4 focus:text-indigo-500">
                                {{ preOrder.lake.name }}
                            </p>
                        </td>
                        <td class="border-t">
                            <p class="flex items-center px-6 py-4 focus:text-indigo-500">
                                {{ preOrder.point?.name ?? '' }}
                            </p>
                        </td>
                        <td class="border-t">
                            <p class="flex items-center px-6 py-4 focus:text-indigo-500">
                                {{ preOrder.type.name }}
                            </p>
                        </td>
                        <td class="border-t">
                            <p class="flex items-center px-6 py-4 focus:text-indigo-500">
                                {{ formattedDate(preOrder.start_date) }}
                            </p>
                        </td>
                        <td class="border-t">
                            <a
                                v-if="order.is_payed"
                                class="flex items-center justify-center focus:text-indigo-500"
                                :href="$route('invoice.download', encodeBase64(order.id))"
                            >
                                <icon role="button" name="downloadPdf" class="block w-6 h-6 fill-gray-400"/>
                            </a>
                            <button
                                v-else-if="!order.is_payed && couldBePayed(preOrder)"
                                class="items-center h-12 btn-indigo uppercase tracking-widest btn-booking text-uppercase rounded-lg justify-center"
                                @click="checkout(order.id)"
                            >
                                Заплатити
                            </button>
                            <span
                                v-else
                                class="flex items-center justify-center focus:text-indigo-500"
                            >
                                --
                            </span>
                        </td>
                    </tr>
                </table>
            </div>
            <pagination class="mt-6" :links="orders.links"/>
        </div>
    </div>
</template>

<script>
import {Head} from '@inertiajs/inertia-vue3'
import Header from "@/Component/Header"
import {Link} from '@inertiajs/inertia-vue3'
import Checkbox from "@/Shared/Checkbox";
import Icon from "@/Shared/Icon.vue";
import Pagination from "@/Shared/Pagination";
import {route} from "ziggy-js";
import LoadingButton from "@/Shared/LoadingButton.vue";

export default {
    components: {
        LoadingButton,
        Pagination,
        Icon,
        Checkbox,
        Header,
        Head,
        Link
    },
    props: {
        cartCount: {
            type: Number,
            default: 0
        },
        user: {
            type: Object,
            default: () => ({}),
        },
        orders: Object,
    },
    methods: {
        route,
        checkout(order_id) {
            this.$inertia.post(this.$route('cabinet.checkout', order_id))
        },
        couldBePayed(preOrder) {
            if(preOrder.is_cancel) {
                return false
            }
            const created_time = new Date(preOrder.created_at);
            const now = new Date();
            const diffTime = Math.abs(now - created_time);
            const diffMinutes = Math.ceil(diffTime / (1000 * 60));
            return diffMinutes < 30
        },
        formattedDate(dateString) {
            const date = new Date(dateString);
            return date.toLocaleDateString('uk-UK', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        },
        encodeBase64(id) {
            return Buffer.from(id.toString()).toString('base64')
        }
    },
    computed: {
        isOwner() {
            return this.user && this.user.owner
        }
    }
}
</script>
